var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.79 12.182 1.601.902a1.01 1.01 0 0 0 1.21-.166l5.342-5.343a1.01 1.01 0 0 0 .166-1.21l-.902-1.6a1.514 1.514 0 0 1 .25-1.815L14.854.551a1.515 1.515 0 0 1 2.142 0l1.09 1.089a4.04 4.04 0 0 1 .607 4.934l-.547.911a31.66 31.66 0 0 1-11.441 11.2l-.108.063a4.046 4.046 0 0 1-4.886-.637L.575 16.975a1.513 1.513 0 0 1 0-2.142l2.4-2.4a1.514 1.514 0 0 1 1.815-.25"
  })));
};
export default SvgPhone;